// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__37ITH","form-field":"Form_form-field__PTra6","checkbox":"Form_checkbox__3fS_a"};